import { gql } from '@apollo/client';

export const postEsClienteCajas = gql`
mutation EsClienteCajasRQ{
    esClienteCajas(input:$input)  
    @rest(type: "EsClienteCajasRS", path: "/api/gateway/motorweb/validargenerico",method:"POST"){
            accion
            sge
            baseNegativa
            sucursal
            token
    }
}
`